// ReusableSlider.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MultipleItemSlider= ({
  items = [],
  settings = {},
  renderItem,
  className = "",
}) => {
  const defaultSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    arrows: true,

    
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1 },
      },
    ],
    ...settings,
  };

  const CustomPrevArrow = ({ className, style, onClick }) => (
    <button type="button" className={`${className} custom-arrow`} style={style} onClick={onClick} disabled={!onClick} aria-label="Prev">
      <i className="fa-solid fa-angle-left"></i>
    </button>
  );

  const CustomNextArrow = ({ className, style, onClick }) => (
    <button type="button" className={`${className} custom-arrow`} style={style} onClick={onClick} disabled={!onClick} aria-label="Next">
      <i className="fa-solid fa-angle-right"></i>
    </button>
  );

  
  return (
    <div className={`reusable-slider ${className}`}>
      <Slider
        {...defaultSettings}
        prevArrow={<CustomPrevArrow />}
        nextArrow={<CustomNextArrow />}
      >
        {items.map((item, index) => (
          <div key={index}>{renderItem(item, index)}</div>
        ))}
      </Slider>
    </div>
  );
};

export default MultipleItemSlider;
